import {
  MemberWithdrawalDrawer,
  MemberWithdrawalsFilters,
  MemberWithdrawalsTable
} from '@bo-components/members/memberWithdrawals';
import { useCallback, useState } from 'react';
import { MemberDrawer } from '@bo-components/members/drawer';
import type { Withdrawal } from '@library/types/payments';
import { useMemberPayments } from '@bo-hooks/members';
import { useMemberPaymentsFilters } from '@bo-hooks/members/useMemberPaymentsFilters';

export const MemberWithdrawals = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedWithdrawal, setSelectedWithdrawal] = useState<Withdrawal>();

  const {
    onChangePaymentsFilter,
    onResetPaymentsFilters,
    paymentsSearchFilters
  } = useMemberPaymentsFilters();

  const { isPaymentsLoading, withdrawals } = useMemberPayments({
    paymentsSearchFilters
  });

  const handleOpenDrawer = useCallback(
    (id: string) => {
      const withdrawal = withdrawals.find(
        ({ merchantReferenceId }) => merchantReferenceId === id
      );

      if (withdrawal) {
        setIsDrawerOpen(true);
        setSelectedWithdrawal(withdrawal);
      }
    },
    [withdrawals]
  );

  const handleCloseDrawer = useCallback(() => {
    setIsDrawerOpen(false);
  }, []);

  return (
    <section
      className="flex flex-col gap-4 px-6"
      data-testid="member-withdrawals"
    >
      <MemberWithdrawalsFilters
        memberPaymentsSearchFilters={paymentsSearchFilters}
        onChangeWithdrawalsFilter={onChangePaymentsFilter}
        onResetWithdrawalsFilters={onResetPaymentsFilters}
      />
      <MemberWithdrawalsTable
        isLoading={isPaymentsLoading}
        withdrawals={withdrawals}
        onRowClick={handleOpenDrawer}
      />
      <MemberDrawer isOpen={isDrawerOpen} onCloseDrawer={handleCloseDrawer}>
        {!!selectedWithdrawal && (
          <MemberWithdrawalDrawer
            withdrawal={selectedWithdrawal}
            onClose={handleCloseDrawer}
          />
        )}
      </MemberDrawer>
    </section>
  );
};
